class variablesjs2Css {
	add(variable, value) {
		const rootElement = document.documentElement;
		rootElement.style.setProperty('--' + variable, value);
	}
}

export default new variablesjs2Css();
